module.exports = __webpack_public_path__ + "static/media/circular_troopr_logo.3d17d757.svg";